import React from 'react';
import styled from '@benzinga/themetron';

interface ButtonStepInterface {
  customClass?: string;
  title: string;
  onClick: (val: ButtonItem) => void;
  options: ButtonItem[];
  notes?: string;
}

export const ButtonStep: React.FC<ButtonStepInterface> = ({ customClass, notes, onClick, options, title }) => {
  return (
    <ButtonStepWrapper className={`step ${customClass}`}>
      <h2 className="section-h2">{title}</h2>
      <div className="section-container">
        <ButtonCardGroup buttons={options} onClick={onClick} />
        {notes && <div className="notes">{notes}</div>}
      </div>
    </ButtonStepWrapper>
  );
};

export interface ButtonItem {
  name: string | number;
  text: string;
}

interface ButtonProps {
  buttons: ButtonItem[];
  onClick: (val: ButtonItem) => void;
}

export type ButtonCardInterface = {
  btnname: string | number;
  icon?: string;
  text: string;
  onClick?: () => void;
};

export const ButtonCard: React.FC<ButtonCardInterface> = ({ btnname, icon, onClick, text }) => {
  return (
    <button className={`btn-card ${btnname}`} onClick={onClick} type="button">
      {icon && <span className="btn-icon"></span>}
      <span className="btn-label">{text}</span>
    </button>
  );
};

export const ButtonCardGroup: React.FC<ButtonProps> = ({ buttons, onClick }) => {
  return (
    <ButtonCardGroupWrapper>
      <div className="btn-card-group">
        {buttons.map(option => {
          return (
            <ButtonCard btnname={option.name} key={option.name} onClick={() => onClick(option)} text={option.text} />
          );
        })}
      </div>
    </ButtonCardGroupWrapper>
  );
};

const ButtonStepWrapper = styled.section`
  .section-h2 {
    font-size: 2rem;
    text-align: center;
    padding: 0.8rem;
  }
`;

const ButtonCardGroupWrapper = styled.div`
  .btn-card-group .btn-card {
    border-radius: 8px;
    background-color: #fff;
    -webkit-box-shadow: 0 0 6px 1px hsla(0, 0%, 63.9%, 0.24);
    box-shadow: 0 0 6px 1px hsla(0, 0%, 63.9%, 0.24);
    -webkit-transition: all 0.3s ease;
    -o-transition: all 0.3s ease;
    transition: all 0.3s ease;
    color: #4c5159;
    cursor: pointer;
    width: 220px;
    border: 1px solid #ddd;
    margin: 0.5rem;
  }
  .btn-card {
    border-radius: 8px;
    background-color: #fff;
    -webkit-box-shadow: 0 0 6px 1px hsl(0deg 0% 64% / 24%);
    box-shadow: 0 0 6px 1px hsl(0deg 0% 64% / 24%);
    -webkit-transition: all 0.3s ease;
    -o-transition: all 0.3s ease;
    transition: all 0.3s ease;
    cursor: pointer;
    width: 220px;
    border: solid 1px #ddd;
    margin: 0.5rem;
    .btn-icon {
      display: block;
      margin: 1.25rem auto 0;
      width: 70px;
      height: 70px;
      background-repeat: no-repeat;
      background-position: 50%;
    }
    .btn-label {
      display: block;
      font-size: 1.0625rem;
      font-weight: 400;
      letter-spacing: 0.3px;
      line-height: 1.375rem;
      margin: 5px;
      padding: 1.5rem;
      text-align: center;
    }

    &.phone .btn-icon {
      background-image: url('/next-assets/images/mortgages/phone.svg');
      min-height: 80px;
      background-repeat: no-repeat;
      background-position: center;
    }

    &.refinance .btn-icon {
      background-image: url('/next-assets/images/mortgages/mortgage_refinance.svg');
    }

    &.purchase .btn-icon {
      background-image: url('/next-assets/images/mortgages/mortgage_purchase.svg');
    }

    &.primary .btn-icon {
      background-image: url('/next-assets/images/mortgages/property_use_primary.svg');
    }

    &.secondary .btn-icon {
      background-image: url('/next-assets/images/mortgages/property_use_secondary.svg');
    }

    &.investment .btn-icon {
      background-image: url('/next-assets/images/mortgages/property_use_investment.svg');
    }

    &.single .btn-icon {
      background-image: url('/next-assets/images/mortgages/property_type_single.svg');
    }

    &.multi .btn-icon {
      background-image: url('/next-assets/images/mortgages/property_type_multi.svg');
    }

    &.townhome-condo .btn-icon {
      background-image: url('/next-assets/images/mortgages/property_type_condo.svg');
    }

    &.mobile .btn-icon {
      background-image: url('/next-assets/images/mortgages/property_type_mobile.svg');
    }

    &.fair .btn-icon {
      background-image: url('/next-assets/images/mortgages/fico_rating_fair.svg');
    }

    &.good .btn-icon {
      background-image: url('/next-assets/images/mortgages/fico_rating_good.svg');
    }

    &.very-good .btn-icon {
      background-image: url('/next-assets/images/mortgages/fico_rating_very_good.svg');
    }

    &.excellent .btn-icon {
      background-image: url('/next-assets/images/mortgages/fico_rating_excellent.svg');
    }
  }
`;
